module.exports = __webpack_public_path__ + "img/48740351002109.36cd74bf.png";